export const replaceTokens = (formatStr, ...valueArgs) => {
    const tokenRegex = /{(\d+)}/g;
    const numValues = valueArgs.length;
    return formatStr.replace(tokenRegex, (match, p1) => {
        return p1 < numValues ? valueArgs[+p1].toString() : match;
    });
};
export const buildClassString = (classNames) => {
    const finalClassNames = [];
    Object.keys(classNames).forEach(className => {
        if (classNames[className] === true) {
            finalClassNames.push(className);
        }
    });
    return finalClassNames.join(' ');
};



// WEBPACK FOOTER //
// ./node_modules/@ps/payscale-shared-ui/lib/StringUtils/index.js